import ChannelsSingleton from './ChannelsSingleton';
import AAF from '../../AAF/AAF';
import Utils from '../../utils/Utils';

export const CHANNEL_QUANTITY = 15;

export const getCurrentChannelRange = (groupId = '', availableChannels = []) => {
  const index = availableChannels.findIndex(ch => ch.group_id === groupId);
  const tolerance = Math.floor(CHANNEL_QUANTITY / 2);
  const from = index >= tolerance ? index - tolerance : 0;
  return {
    from,
    quantity: CHANNEL_QUANTITY
  };
}

export const canTimeShift = (event = {}) => {
    // timeshiftAllowed viene en segundos
    const timeshiftAllowed = ChannelsSingleton.getTimeshift(event.channel_group_id || event.group_id) * 60 + AAF.Timeshift.calcTSExcedecTime();
    const nowUnix = Utils.nowAsTimestampSeconds();
    const beginUnix = event.date_begin;
    const endUnix = event.date_end;
    const diffStart = nowUnix - beginUnix;
    const diffEnd = nowUnix - endUnix;
    const startMatch = diffStart <= timeshiftAllowed;
    const endMatch =
      diffEnd <=
      (startMatch ? timeshiftAllowed : timeshiftAllowed - AAF.Timeshift.calcTSExcedecTime());
    let dateBegin;
    if(startMatch){
      dateBegin = event.date_begin
    }
    else{
      dateBegin = nowUnix - timeshiftAllowed
    }
    return diffStart > 0 && (startMatch || endMatch) ? dateBegin : false;
}

export const eventIsInTimeshiftWindow = (event) => {
    // timeshiftAllowed viene en segundos
    const timeshiftAllowedExeded =
      ChannelsSingleton.getTimeshift(event.channel_group_id || event.group_id) * 60 +
      AAF.Timeshift.calcTSExcedecTime();
    const now = Utils.nowAsTimestampSeconds();
    const beginUnix = event.date_begin;
    const endUnix = event.date_end;
    const endTimeshif =
      beginUnix < now - timeshiftAllowedExeded
        ? ChannelsSingleton.getTimeshift(event.channel_group_id || event.group_id) * 60
        : timeshiftAllowedExeded;
    const isIn = endUnix <= now && endUnix > now - endTimeshif ? true : false;
    return isIn;
}

export const canPlayPastEventAsCatchup = event => {
  const groupId = event.channel_group_id || event.group_id;
  const isEventInTimeshiftWindow = eventIsInTimeshiftWindow(event, true);
  const canPlayChannel = ChannelsSingleton.canPlayChannel(groupId)
  const eventHasStartover = event.ext_startover === '1';
  const timeshift_enable_APA = ChannelsSingleton.getTimeshift(groupId);
  const eventCanTimeShift = canTimeShift(event);
  const hasTimeShift = timeshift_enable_APA && (eventHasStartover ? !!eventCanTimeShift : false);
  return canPlayChannel && hasTimeShift && isEventInTimeshiftWindow;
}



// WEBPACK FOOTER //
// ./src/components/Epg/EpgEventUtils.js